import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'components/base'

import { connect } from 'react-redux'
import { compose } from 'recompose'
import history from 'browserHistory'

import providesPaginatedIntegratedApplications from 'components/Integrations/dataSync/providesPaginatedIntegratedApplications'
import { selectors as OrganizationSelectors } from 'data/organizations'

import { Button } from 'components/base'
import IntegrationEntry from '../components/IntegrationEntry'
import RoutesHelper from 'helpers/RoutesHelper'

import EmptyState from './EmptyState'

class OverviewPage extends React.Component {
  static propTypes = {
    integratedApplications: PropTypes.array.isRequired,
  }

  componentDidMount() {
    this.props.fetchNextPage({ startFresh: true })
  }

  handleAddIntegrationClick = event => {
    event.preventDefault()
    history.push(RoutesHelper.settingsIntegrationListApplications())
  }

  render() {
    const { integratedApplications } = this.props
    const hasIntegratedApplications = integratedApplications.length > 0

    return (
      <React.Fragment>
        <div
          className="flexbox flexbox-align-center margin-bottom-large"
          style={{
            justifyContent: hasIntegratedApplications
              ? 'space-between'
              : 'center',
          }}
        >
          {hasIntegratedApplications && (
            <React.Fragment>
              <Text.Subtitle className="font-weight-medium">
                Your integrations
              </Text.Subtitle>
              <Button.Primary onClick={this.handleAddIntegrationClick}>
                Add Integrations
              </Button.Primary>
            </React.Fragment>
          )}
          {hasIntegratedApplications === false && <EmptyState />}
        </div>
        <section className="application-entry-container">
          {this.props.integratedApplications.map((application, index) => (
            <IntegrationEntry {...application} key={index} />
          ))}
        </section>
      </React.Fragment>
    )
  }
}

export default compose(
  providesPaginatedIntegratedApplications(),
  connect(state => ({
    integratedApplications: OrganizationSelectors.getAllIntegratedApplications(
      state
    ),
  }))
)(OverviewPage)
